<template>
  <div>
    <appbar v-if="!$isAgent()" />
    <appbarAgent v-else />

    <v-main>
      <v-container class="mx-auto" style="max-width: 1024px">
        <router-view />
        <footerIns v-if="!$isAgent()" />
      </v-container>
    </v-main>
  </div>
</template>
<script>
import appbar from "@/components/appbar/appbar";
import appbarAgent from "@/components/agent/appbar/appBarAgent";
import footerIns from "@/components/footer/footer";
export default {
  name: "pages",
  components: {
    appbar,
    appbarAgent,
    footerIns,
  },
  // data: () => ({}),
  // mounted() {},
  // computed: {},
};
</script>
